import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IFillFormButtonMobileProps {
  onClick: () => void;
  href: string;
}

export function FillFormButtonMobile({ href, onClick }: IFillFormButtonMobileProps) {
  return (
    <div className={styles['button-container']}>
      <LinkButton
        fullWidth
        href={`https://www.cian.ru${href}?opendealrentform=true`}
        onClick={onClick}
        target="_blank"
        rel="noreferrer"
      >
        Назначить просмотр
      </LinkButton>
    </div>
  );
}
